<template>
  <v-tabs dark icons-and-text grow>
    <v-tabs-slider color="orange"></v-tabs-slider>

    <v-tab href="#tab-1">
      {{$t('rms_avail_active_links_label')}}
      <v-icon color="orange">$vuetify.icons.rms_active</v-icon>
    </v-tab>

    <v-tab href="#tab-2">
      {{$t('rms_avail_expired_links_label')}}
      <v-icon color="orange">$vuetify.icons.rms_disabled</v-icon>
    </v-tab>

    <v-tab-item v-for="i in 2" :key="i" :value="'tab-' + i">
      <ActiveLinks v-if="i == 1"></ActiveLinks>
      <ExpiredLinks v-if="i == 2"></ExpiredLinks>
    </v-tab-item>
  </v-tabs>
</template>
<script>
import i18n from "@/i18n";
import ActiveLinks from "@/components/invitation/activeLinks";
import ExpiredLinks from "@/components/invitation/ExpiredLinks";

export default {
  data() {
    return {
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  components: {
    ActiveLinks,
    ExpiredLinks
  },
  mounted() {
    this.getActiveLinks();
    this.getExpiredLinks();
    this.setToolbarHeader();
  },
  methods: {
    async getActiveLinks() {
      await this.$store.dispatch("avails/getActiveLinks");
    },
    async getExpiredLinks() {
      await this.$store.dispatch("avails/getExpiredLinks");
    },
    async setToolbarHeader() {
      await this.$store.dispatch("app/setToolbarHeader", {
        header: i18n.t("rms.toolbar.header.invitation_status")
      });
    }
  }
};
</script>
